import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { PageHeaderActions } from '../page-header/page-header-actions';

export type PageTemplateVariant = 'page' | 'tab';

const LAYOUT = 'tw:flex tw:min-h-0 tw:flex-auto tw:flex-col tw:gap-[15px]';

/**
 * `page`: a standalone list page. `tab`: the same layout inside a business view tab, with the
 * tabs' own spacing (`fr8bot-business-view-tab`: 35px 40px 40px); below 769px it keeps 20px at
 * the sides instead of the tabs' edge-to-edge cards, since a header and a table need the margin.
 */
const SPACING: Record<PageTemplateVariant, string> = {
  page: 'tw:px-5 tw:pt-5 tw:min-[745px]:px-10 tw:min-[745px]:pt-10',
  tab: 'tw:px-10 tw:pt-[35px] tw:pb-10 tw:max-[768px]:px-5 tw:max-[768px]:pt-5 tw:max-[768px]:pb-5',
};

@Component({
  selector: 'fr8bot-ui-page-template',
  templateUrl: './page-template.component.html',
  host: { '[class]': 'hostClass()' },
  providers: [PageHeaderActions],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageTemplateUIComponent {
  readonly variant = input<PageTemplateVariant>('page');

  protected readonly hostClass = computed(() => `${LAYOUT} ${SPACING[this.variant()]}`);
}
